import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-basic/basic/article/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryWithKeyword(payload) {
  return request(`/iwms-basic/basic/article/pageWithKeyword`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryArticleWithKeyword(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/pageArticleWithKeyword`, {
    method: 'POST',
    body: payload,
  });
}

export async function save(payload) {
  return request(`/iwms-basic/basic/article`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-basic/basic/article/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return request(`/iwms-basic/basic/article/${payload.uuid}`);
}

export async function getByDc(payload) {
  return request(`/iwms-basic/basic/article/${payload.uuid}/getByDc?dcUuid=${loginOrg().uuid}`);
}

export async function getArticlesByUuids(payload) {
  return request(`/iwms-basic/basic/article/query/uuids`, {
    method: 'POST',
    body: payload,
  });
}

export async function getArticlesByUuidsByDc(payload) {
  return request(`/iwms-basic/basic/article/query/uuids/dc?dcUuid=${loginOrg().uuid}`, {
    method: 'POST',
    body: payload,
  });
}

export async function online(payload) {
  return request(`/iwms-basic/basic/article/${payload.uuid}/online?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function offline(payload) {
  return request(`/iwms-basic/basic/article/${payload.uuid}/offline?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function batchImport(payload) {
  return request(`/iwms-basic/basic/article/batchImport?companyUuid=${loginCompany().uuid}&fileKey=${payload.fileKey}&type=${payload.type}`, {
    method: 'POST'
  });
}

// export async function getImportTemplateUrl(payload) {
//   return request(`/iwms-basic/basic/article/templet/download?type=${payload.type}`);
// }

export async function saveOrModifyArticleQpc(payload) {
  return request(`/iwms-basic/basic/article/qpc`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyArticleBarcode(payload) {
  return request(`/iwms-basic/basic/article/barcode`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyArticleVendor(payload) {
  return request(`/iwms-basic/basic/article/vendor`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyStorePickQty(payload) {
  return request(`/iwms-basic/basic/article/storePickQty`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyArticleStorPrice(payload) {
  return request(`/iwms-basic/basic/article/storePrice`, {
    method: 'POST',
    body: payload,
  });
}

export async function removeArticleQpc(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/qpc/${payload.uuid}/remove`, {
    method: 'DELETE',
  });
}

export async function removeArticleBarcode(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/barcode/${payload.uuid}/remove`, {
    method: 'DELETE',
  });
}

export async function removeArticleVendor(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/vendor/${payload.uuid}/remove`, {
    method: 'DELETE',
  });
}

export async function removeStorePickQty(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/storePickQty/${payload.uuid}/remove`, {
    method: 'DELETE',
  });
}

export async function removeArticleStorPrice(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/storePrice/${payload.uuid}/remove`, {
    method: 'DELETE',
  });
}

export async function getQpcsByArticleUuid(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/qpc`);
}

export async function getQpcsByArticleUuidByDc(payload) {
  return request(`/iwms-basic/basic/article/${payload.articleUuid}/qpcbydc?dcUuid=${loginOrg().uuid}`);
}

export async function queryByUuids(payload) {
  return request(`/iwms-basic/basic/article/query/uuids`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyArticleDcVendor(payload) {
  return request(`/iwms-basic/basic/articleDcVendor`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyArticleDC(payload) {
  return request(`/iwms-basic/basic/article/dc`, {
    method: 'POST',
    body: payload,
  });
}

export async function removeArticleDC(payload) {
  return request(`/iwms-basic/basic/article/dc/${payload.uuid}/remove`, {
    method: 'DELETE'
  });
}

export async function batchSaveDC(payload) {
  return request(`/iwms-basic/basic/article/${payload.uuid}/dcbatchsave?companyUuid=${payload.companyUuid}`, {
    method: 'POST',
    body: payload.dcs,
  });
}

export async function getByCodeAndCompanyUuid(payload) {
  return request(`/iwms-basic/basic/article/getByCodeAndCompanyUuid?code=${payload.code}&companyUuid=${payload.companyUuid}`);
}

export async function articleControlDayssaveOrModify(payload) {
  return request(`/iwms-wms/wms/articleControlDays/saveOrModify`, {
    method: 'POST',
    body: payload
  })
}

export async function getByArticleCode(payload) {
  return request(`/iwms-wms/wms/articleControlDays/getByArticleCode?dcUuid=${payload.dcUuid}&articleCode=${payload.articleCode}&companyUuid=${loginCompany().uuid}`)
}


export async function queryByBarcode(payload) {
  return request(`/iwms-basic/basic/article/queryByBarcode?barcode=${payload.barcode}&companyUuid=${payload.companyUuid}`,{
    method: 'GET',
  })
}

export async function qpcs(payload) {
  return request(`/iwms-basic/basic/article/qpcs`,{
    method: 'POST',
    body: payload
  })
}

export async function querydays(payload){
  return request(`/iwms-wms/wms/articleControlDays/querydays?dcUuid=${payload.dcUuid}`,{
    method:'POST',
    body:payload.uuids
  })
}

export async function getBillArticlePrice(payload){
  return request(`/iwms-wms/wms/billprice/getBillArticlePrice`,{
    method:'POST',
    body: payload
  })
}
